import React, { useEffect, useState } from 'react'
import menuMd from '../../../docs/menu.md'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

export const DocsMenu = () => {

    const [page, setPage] = useState(null)

    useEffect(() => {
        fetch(menuMd).then((menuMd) => menuMd.text()).then((menuMd) => setPage(menuMd))
    }, [])

    return (
        <ReactMarkdown
            components={{
                ul: ({ node, ...props }) => (
                    <ul className='ul-md' {...props}></ul>
                ),
                li: ({ node, ...props }) => (
                    <li className='li-md' {...props}></li>
                )
            }}
        >
            {page}
        </ReactMarkdown>
    )
}
